(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["complementary-products"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
          setupCardSwiping();
          setupSlider();
          setupScrollTrack();
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  function setupCardSwiping() {
    const swipeTracks = document.querySelectorAll('#complementaryProducts .card-product--image-swipe-track');
    swipeTracks.forEach((swipeTrack) => {
      const leftArrow = swipeTrack.closest('.card-product--image-swipe-container').querySelector('.pcpa-left');
      const rightArrow = swipeTrack.closest('.card-product--image-swipe-container').querySelector('.pcpa-right');
      const paginationBullets = swipeTrack
        .closest('.card-product--image-swipe-container')
        .querySelectorAll('.product-card--pagination-bullet');

      const updateArrowState = () => {
        const maxScrollLeft = swipeTrack.scrollWidth - swipeTrack.clientWidth;
        if (swipeTrack.scrollLeft <= 0) {
          leftArrow.classList.add('faded');
        } else {
          leftArrow.classList.remove('faded');
        }

        if (swipeTrack.scrollLeft >= maxScrollLeft - 2) {
          rightArrow.classList.add('faded');
        } else {
          rightArrow.classList.remove('faded');
        }
      };

      const updatePagination = () => {
        const scrollLeft = swipeTrack.scrollLeft;
        const slideWidth = swipeTrack.querySelector('.card-product--image-slide')?.clientWidth || 1;
        const activeIndex = Math.round(scrollLeft / slideWidth) + 1;

        paginationBullets.forEach((bullet) => {
          if (parseInt(bullet.dataset.value, 10) === activeIndex) {
            bullet.classList.add('active');
          } else {
            bullet.classList.remove('active');
          }
        });
      };

      const onScroll = () => {
        updateArrowState();
        updatePagination();
      };

      swipeTrack.addEventListener('scroll', onScroll);

      leftArrow.addEventListener('click', () => {
        event.preventDefault(); // Prevent the link's default behavior
        const slideWidth = swipeTrack.querySelector('.card-product--image-slide')?.clientWidth || 1;
        swipeTrack.scrollBy({
          left: -slideWidth,
          behavior: 'smooth',
        });
      });

      rightArrow.addEventListener('click', () => {
        event.preventDefault(); // Prevent the link's default behavior
        const slideWidth = swipeTrack.querySelector('.card-product--image-slide')?.clientWidth || 1;
        swipeTrack.scrollBy({
          left: slideWidth,
          behavior: 'smooth',
        });
      });

      // Initialize states
      updateArrowState();
      updatePagination();
    });
  }

  function setupSlider() {
    const sliderWrapper = document.querySelector('#complementaryProducts .comp-products-grid-wrapper');
    const sliderContainer = document.querySelector('#complementaryProducts .comp-products-grid');
    const leftArrow = document.querySelector('#complementaryProducts .slider-arrow-left');
    const rightArrow = document.querySelector('#complementaryProducts .slider-arrow-right');

    if (!sliderContainer || !leftArrow || !rightArrow) return;

    const setArrowState = () => {
      const scrollPosition = sliderContainer.scrollLeft;
      const containerWidth = sliderContainer.clientWidth;
      const totalWidth = sliderContainer.scrollWidth;
      const scrollLimit = totalWidth - containerWidth;

      // Find the first image element within the slider-grid
      const firstImage = sliderContainer.querySelector('img');
      
      // Get the height of the first image
      const imageHeight = firstImage ? firstImage.clientHeight : 0;

      // Apply top margin to arrows based on half of the image height
      if (sliderWrapper.classList.contains('slider-arrows-position-middle') && leftArrow && rightArrow && imageHeight !== 0) {
        const marginTop = (imageHeight * 0.5) - 24;
        leftArrow.style.marginTop = marginTop + 'px';
        rightArrow.style.marginTop = marginTop + 'px';
      }      
      
      if (scrollPosition <= 0) {
        leftArrow.classList.add('disabled');
      } else {
        leftArrow.classList.remove('disabled');
      }

      if (scrollPosition >= scrollLimit - 2) {
        rightArrow.classList.add('disabled');
      } else {
        rightArrow.classList.remove('disabled');
      }
    };

    setArrowState();

    sliderContainer.addEventListener('scroll', setArrowState);
    window.addEventListener('resize', setArrowState);

    function scrollToSnap(direction) {
      const items = sliderContainer.querySelectorAll('.grid__item');
      if (!items.length) return;

      const currentScroll = sliderContainer.scrollLeft;

      let closestIndex = 0;
      let closestDistance = Infinity;

      items.forEach((item, index) => {
        const distance = Math.abs(item.offsetLeft - currentScroll);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      const targetIndex = Math.max(
        0,
        Math.min(items.length - 1, closestIndex + direction)
      );

      sliderContainer.scrollTo({
        left: items[targetIndex].offsetLeft,
        behavior: 'smooth',
      });
    }

    leftArrow.addEventListener('click', () => scrollToSnap(-1));
    rightArrow.addEventListener('click', () => scrollToSnap(1));
  }

  // Slider custom scrollbar

  function setupScrollTrack() {
    const wrapper = document.querySelector('#complementaryProducts .comp-products-grid-wrapper');
    if (wrapper) {
      const slider = wrapper.querySelector('#complementaryProducts .comp-products-grid');
      const track = wrapper.querySelector('.slider-custom-scrollbar-track');
      const marker = wrapper.querySelector('.slider-custom-scrollbar-marker');
    
      if (slider && track && marker) {
        function updateMarkerWidthAndVisibility() {
          const visibleWidth = slider.clientWidth;
          const scrollableWidth = slider.scrollWidth;
    
          if (scrollableWidth <= visibleWidth) {
            track.classList.add('hidden');
          } else {
            track.classList.remove('hidden');
            const trackWidth = track.clientWidth;
            const markerWidth = (visibleWidth / scrollableWidth) * trackWidth;
            marker.style.width = `${markerWidth}px`;
          }
        }
    
        function updateMarkerPosition() {
          const scrollLeft = slider.scrollLeft;
          const scrollableWidth = slider.scrollWidth - slider.clientWidth;
          const trackWidth = track.clientWidth - marker.clientWidth;
    
          const left = (scrollableWidth > 0) ? (scrollLeft / scrollableWidth) * trackWidth : 0;
          marker.style.transform = `translateX(${left}px)`;
        }
    
        // Initial setup
        updateMarkerWidthAndVisibility();
        updateMarkerPosition();
    
        // On scroll
        slider.addEventListener('scroll', updateMarkerPosition);
    
        // On window resize
        window.addEventListener('resize', () => {
          updateMarkerWidthAndVisibility();
          updateMarkerPosition();
        });
      }
    }
  }
  

  } catch(e) { console.error(e); }
})();
})();
